
const state = {
    active_menu: 0, //页面导航，默认在首页
}

//申明同步

const mutations = {
    setState(state,obj){
        state.active_menu = obj.num
    }
}

export default {
    state,
    mutations
}